import { ReactNode } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { LucideIcon } from 'lucide-react'

interface SidebarItemProps {
  name: string
  href: string
  icon: LucideIcon
  sidebarCollapsed?: boolean
  onClick?: () => void
  children?: ReactNode
  isActive?: boolean
}

export function SidebarItem({ 
  name, 
  href, 
  icon: Icon, 
  sidebarCollapsed = false, 
  onClick,
  children,
  isActive: providedIsActive
}: SidebarItemProps) {
  const location = useLocation()
  const isActive = providedIsActive ?? (location.pathname === href || location.pathname.startsWith(href + '/'))

  return (
    <div className="space-y-1">
      <Link
        to={href}
        className={cn(
          "flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors",
          isActive
            ? "bg-primary text-primary-foreground"
            : "text-muted-foreground hover:bg-accent hover:text-accent-foreground",
          sidebarCollapsed && "justify-center px-2"
        )}
        onClick={onClick}
        title={sidebarCollapsed ? name : undefined}
      >
        <Icon className="h-5 w-5 flex-shrink-0" />
        {!sidebarCollapsed && <span>{name}</span>}
      </Link>
      {children && !sidebarCollapsed && (
        <div className="ml-8 space-y-1">
          {children}
        </div>
      )}
    </div>
  )
}
